import { useConditionFieldPath } from './useConditionFieldPath';

export const useConditionComparatorFieldPath = () => {
  const condition = useConditionFieldPath();
  return `${condition}.comparatorType` as const;
};
